export class Timing {
	public static waitAsync(delayInMs: number): Promise<void> {
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve();
			}, delayInMs);
		});
	}
}